import { ApiApplicantProfile } from 'api/applicantProfile/types/ApiApplicantProfile';
import { MainStoreUserEnvironmentState } from 'store/ducks/userEnvironment';
import { isDefined } from 'utils/functional';
import { getItem } from 'utils/localStorage';
import { isNonAdmin } from 'utils/userEnvironment';

export function hasResumeDb(
  userEnvironment: MainStoreUserEnvironmentState,
): boolean {
  return Boolean(
    getItem('enableResumeDb') !== false &&
      (userEnvironment.environment?.isUS ||
        userEnvironment.user?.isRecruitable) &&
      CURRENT_LOCALE === 'en',
  );
}

export function hasWorkHistoryJobs(profile?: ApiApplicantProfile): boolean {
  return Boolean(
    profile?.workHistoryJobs && profile.workHistoryJobs.length > 0,
  );
}

export function promoteResumeDatabase({
  userEnvironment,
  allowLoggedOut,
}: {
  userEnvironment: MainStoreUserEnvironmentState;
  allowLoggedOut?: boolean;
}) {
  return Boolean(
    userEnvironment.isUserLoaded &&
      userEnvironment.isEnvironmentLoaded &&
      hasResumeDb(userEnvironment) &&
      ((allowLoggedOut && !userEnvironment.user) ||
        // @ts-expect-error TS(2345): Argument of type 'ApiUser | undefined' is not assi... Remove this comment to see the full error message
        (isNonAdmin(userEnvironment.user) &&
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          (!isDefined(userEnvironment.user.isRecruitable) ||
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            (userEnvironment.user.isRecruitable &&
              // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              !userEnvironment.user.resumeId)))),
  );
}
